import { Stack, TablePagination } from "@mui/material";
import { DataGridProProps } from "@mui/x-data-grid-pro";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";

type Props = Pick<DataGridProProps, "rows" | "columns" | "getRowId" | "loading"> & {
  tableName: string;
  pagination: {
    page: number;
    rowsPerPage: number;
    totalItems: number;
  };
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

export const ControleTable = ({
  tableName,
  pagination,
  onPageChange,
  onRowsPerPageChange,
  ...props
}: Props) => {
  return (
    <Stack spacing={0}>
      <StyledDataGrid
        {...props}
        tableName={tableName}
        rowCount={pagination.totalItems}
        disableRowSelectionOnClick={true}
        hideFooter={true}
        className="border-x"
        pageSizeOptions={[10, 25, 50, 100]}
        paginationMode="server"
        paginationModel={{
          page: pagination.page - 1,
          pageSize: pagination.rowsPerPage,
        }}
      />
      <TablePagination
        component="div"
        count={pagination.totalItems}
        page={pagination.page - 1}
        onPageChange={(_, page) => onPageChange(page)}
        rowsPerPageOptions={[10, 25, 50, 100]}
        rowsPerPage={pagination.rowsPerPage}
        onRowsPerPageChange={(event) => onRowsPerPageChange(parseInt(event.target.value, 10))}
      />
    </Stack>
  );
};
